import { useEffect, useRef, useState } from 'react';

import { Role } from '../types/member.types';
import { membersService } from '../services/members.service';

// API call to fetch roles
const fetchRoles = async (): Promise<Role[]> => {
  const response = await membersService.getRoles();
  if (!response) {
    throw new Error('Failed to fetch roles');
  }
  // API response structure: { data: [...], timestamp, requestId }
  return response;
};

export const useRoles = () => {
  const hasInitialized = useRef(false);
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const loadRoles = async () => {
    try {
      setLoading(true);
      const data = await fetchRoles();
      setRoles(data);
    } catch (err) {
      console.error('Error loading departments:', err);
      setError(err instanceof Error ? err.message : 'Failed to load departments');
    } finally {
      setLoading(false);
    }
  };

  // Auto-load departments on first use - prevent duplicate calls
  useEffect(() => {
    if (!hasInitialized.current && roles.length === 0 && !loading && !error) {
      hasInitialized.current = true;
      void loadRoles();
    }
  }, []); // Empty dependency array - only run once

  return {
    roles,
    loading,
  };
};
